import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { incidentOperations } from '../../redux/incident';

import MultiSelectFilterItem from './MultiSelectFilterItem';
import FreeformFilterItem from './FreeformFilterItem';

import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

import theme from '../../muiTheme';

class FilterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  updateFilter = filter => {
    this.props.updateIncidentFilterValues(filter);
  };

  hasFilter = () => {
    let hasFilter = false;

    Object.keys(this.props.filters).forEach(key => {
      const filter = this.props.filters[key];
      if (filter.values.length) {
        hasFilter = true;
      }
    });

    return hasFilter;
  };

  getFilterItems = filters => {
    return Object.keys(filters).map(key => {
      const filter = filters[key];

      if (filter.container === 'drawer') {
        let filterItem;
        switch (filter.type) {
          case 'multiSelect':
            filterItem = (
              <MultiSelectFilterItem
                filterName={filter.name}
                label={filter.label}
                fieldNames={filter.fieldNames}
                type={filter.type}
                values={filter.values}
                options={filter.options}
                onChange={this.updateFilter}
              />
            );
            break;
          case 'freeform':
            filterItem = (
              <FreeformFilterItem
                filterName={filter.name}
                label={filter.label}
                fieldNames={filter.fieldNames}
                type={filter.type}
                values={filter.values}
                onChange={this.updateFilter}
              />
            );
            break;
          default:
            return false;
        }

        /* eslint-disable */
        return (
          <div key={filter.name} style={styles.filterItem}>
            <label style={styles.filterLabel}>{filter.label}</label>
            {filterItem}
          </div>
        );
        /* eslint-enable */
      }
      return null;
    });
  };

  render() {
    return (
      <div style={styles.filterContainer}>
        {this.getFilterItems(this.props.filters)}
        <IconButton
          style={{
            visibility: this.hasFilter() ? 'visible' : 'hidden'
          }}
          onClick={this.props.clearIncidentFilters}
          tooltip="Clear filter"
        >
          <CloseIcon />
        </IconButton>
      </div>
    );
  }
}

const styles = {
  filterContainer: {
    display: 'flex',
    borderTop: `1px solid ${theme.palette.borderColor}`,
    borderBottom: `1px solid ${theme.palette.borderColor}`,
    padding: '10px 0 10px 5px',
    alignItems: 'flex-end'
  },
  filterItem: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 50px',
    padding: '15px 5px 0 5px'
  },
  filterLabel: {
    color: theme.palette.secondaryTextColor,
    fontSize: '0.9em',
    fontWeight: '300'
  }
};

const mapStateToProps = state => ({
  filters: state.incident.filters
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...incidentOperations
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterContainer);



// WEBPACK FOOTER //
// ./src/components/filter/FilterContainer.js